import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { FooterComponent } from '../../../shared/components/footer/footer';
import { HeaderComponent } from '../components/header/header';
import { SidenavComponent } from '../components/sidenav/sidenav';

@Component({
  selector: 'app-main-layout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterOutlet, 
    MatSidenav,
    MatSidenavContainer,
    MatSidenavContent,
    FooterComponent,
    HeaderComponent,
    SidenavComponent
  ],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss',
})
export class MainLayoutComponent {
}
